<template>
    <div class="peugeot-page page-wrapper">
        <ynk-cssgrid-layout>

            <div class="title">
                <h1>Peugeot <br/>DOOH</h1>
            </div>
            <div class="title-panel">
                <div class="actual-panel">
                    <h3>Digital Out Of Home</h3>
                    <p>Meerdere realtime DOOH toepassingen op Dynamic Displays</p>

                    <!-- <router-link to="/work/spa">Next case</router-link> -->
                </div>

                <router-link tag="button" class="view-case-button" to="/work/peugeot/details">View case</router-link>
            </div>
        </ynk-cssgrid-layout>

        <nav-bar></nav-bar>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import NavBar from '@/app/components/NavBar';
    import CssGrid from '@/app/layouts/CssGrid';

    export default {
        name: 'PeugeotCase',

        components: {
            'nav-bar': NavBar,
            'ynk-cssgrid-layout': CssGrid
        },

        methods: {
            getAnimateIn()
            {
                let tl = new TimelineMax();

                // tl.staggerFrom( this.$el.querySelectorAll( '.title-panel, .title' ), 0.5, { x: -50, autoAlpha: 0 }, 0 );
                // tl.from( this.$el.querySelector( '.visual' ), 0.5, { x: 50, autoAlpha: 0 }, 0.3 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                // tl.to( this.$el.querySelectorAll( '.title-panel, .title' ), 1, { rotation: 900, y: 50, autoAlpha: 0 }, 0 );
                // tl.to( this.$el.querySelector( '.visual' ), 1, { x: 50, autoAlpha: 0 }, 0 );

                // tl.to( this.$el, 0.5, { opacity: 0 }, 0 );

                return tl;
            }
        }
    };
</script>
